import React, { useCallback, useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import ChatPanel from './ChatPanel';

const ChatLauncher: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [hasPendingActivity, setHasPendingActivity] = useState(false);

  const refreshPendingFromServer = useCallback(async () => {
    try {
      const list = await apiService.listChatSessions();
      setHasPendingActivity(list.some((s) => s.hasPendingReply));
    } catch {
      // Ignore — launcher badge is best-effort when panel is closed.
    }
  }, []);

  useEffect(() => {
    if (open) return;
    void refreshPendingFromServer();
    const interval = window.setInterval(() => void refreshPendingFromServer(), 5000);
    return () => window.clearInterval(interval);
  }, [open, refreshPendingFromServer]);

  return (
    <>
      <button
        type="button"
        aria-label="Open AI assistant chat"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className={`fixed bottom-6 right-6 z-30 w-14 h-14 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/30 hover:bg-primary/90 active:scale-95 transition-all ${
          open ? 'opacity-0 pointer-events-none scale-90' : 'opacity-100'
        }`}
      >
        <span
          className="material-symbols-outlined text-2xl"
          style={{ fontVariationSettings: "'FILL' 1" }}
        >
          chat
        </span>
        <span
          className={`absolute top-1 right-1 w-3 h-3 bg-tertiary border-2 border-surface rounded-full ${
            hasPendingActivity ? 'animate-pulse' : ''
          }`}
          aria-hidden
        />
      </button>

      <ChatPanel
        open={open}
        onClose={() => setOpen(false)}
        onPendingActivityChange={setHasPendingActivity}
      />
    </>
  );
};

export default ChatLauncher;
